export const ANALYTICS_APP_ID = "truegrind";

export const TRUE_GRIND_HOSTNAMES = [
  "grindlike.pro",
  "www.grindlike.pro",
  "true-grind-cs2.online",
  "www.true-grind-cs2.online",
  "app.true-grind-cs2.online",
] as const;
